import { getFormattedLocalDate, getFormattedLocalTime } from "../../common/Utilities";

const CellTDDateAndTime: React.FC<{ data: any, data_key: string }> = ({ data, data_key }) => {

    return (
        <><p style={{ marginBottom: "0px" }}>{getFormattedLocalDate(data[data_key])}</p><p style={{ marginBottom: "0px" }}>{getFormattedLocalTime(data[data_key])}</p></>
    )
}

export default CellTDDateAndTime;